import ApiClient from './ApiClient';

class DevDocs extends ApiClient {
  constructor() {
    super('dev_docs', { accountScoped: true });
  }
}

export default new DevDocs();
